import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "tools"
    }}>{`Tools`}</h1>
    <p>{`The most important tools you`}{`’`}{`ll need when working with Adobe I/O Runtime are:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "cli_install.md"
        }}>{`aio CLI`}</a>{`: helps you manage your namespaces and the authentication for the `}<inlineCode parentName="li">{`aio`}</inlineCode>{` CLI`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "wsk_install.md"
        }}>{`wsk CLI`}</a>{`: the main interface for managing your actions/packages/rules/triggers and get access to activation results/errors/logs`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "wskdeploy_install.md"
        }}>{`wskdeploy CLI`}</a>{`: helps you deploy multiple actions and packages`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      